<template>
  <div>
    <!-- Topbar -->
    <nav
      class="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow"
    >
      <!-- Sidebar Toggle (Topbar) -->
      <button
        id="sidebarToggleTop"
        class="btn btn-link d-md-none rounded-circle mr-3"
      >
        <i class="fa fa-bars"></i>
      </button>

      <!-- Topbar Search -->
      <form
        class="d-none d-sm-inline-block form-inline mr-auto ml-md-3 my-2 my-md-0 mw-100 navbar-search"
        @submit.prevent="getDemands"
        v-if="userPermissions.some((e) => [P_READ_DEMAND].includes(e))"
      >
        <div class="input-group">
          <input
            type="text"
            class="form-control bg-light border-0 small"
            placeholder="Référence..."
            aria-label="Search"
            aria-describedby="basic-addon2"
            v-model="identifiant"
          />
          <div class="input-group-append">
            <button class="btn btn-primary" type="submit">
              <i class="fas fa-search fa-sm"></i>
            </button>
          </div>
        </div>
      </form>

      <!-- <button v-on:click="sendMessage('hello')">Send Message</button> -->

      <div class="alert alert-warning mt-3" role="alert" v-if="isIdle">
        Nous avons constaté une inactivité depuis <strong>15 minutes</strong>.
        Vous serez déconnecté dans <strong>{{ second }} seconde(s)</strong>.
        Veuillez bouger votre souris.
      </div>

      <!-- Topbar Navbar -->
      <ul class="navbar-nav ml-auto">
        <!-- Nav Item - Search Dropdown (Visible Only XS) -->
        <li class="nav-item dropdown no-arrow d-sm-none">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="searchDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-search fa-fw"></i>
          </a>
          <!-- Dropdown - Messages -->
          <div
            class="dropdown-menu dropdown-menu-right p-3 shadow animated--grow-in"
            aria-labelledby="searchDropdown"
          >
            <form class="form-inline mr-auto w-100 navbar-search">
              <div class="input-group">
                <input
                  type="text"
                  class="form-control bg-light border-0 small"
                  placeholder="Search for..."
                  aria-label="Search"
                  aria-describedby="basic-addon2"
                />
                <div class="input-group-append">
                  <button class="btn btn-primary" type="button">
                    <i class="fas fa-search fa-sm"></i>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </li>

        <!-- Nav Item - Alerts -->
        <li class="nav-item dropdown no-arrow mx-1">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="alertsDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-bell fa-fw"></i>
            <!-- Counter - Alerts -->
            <span
              class="badge badge-danger badge-counter"
              title="Alertes Demandes en attente"
              >{{ nombreDemandeEnAttente }}</span
            >
          </a>
          <!-- Dropdown - Alerts -->
          <div
            class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
            aria-labelledby="alertsDropdown"
          >
            <h6 class="dropdown-header">Alertes Demandes en attente</h6>
            <div
              v-if="
                !(
                  Object.keys(matcheds).length === 0 &&
                  matcheds.constructor === Object
                )
              "
            >
              <button
                v-for="demand in matcheds.data.slice(0, 5)"
                :key="demand.id"
                class="dropdown-item d-flex align-items-center"
                to="#"
                @click="view(demand.id)"
              >
                <div class="mr-3">
                  <div class="icon-circle bg-primary">
                    <i class="fas fa-file-alt text-white"></i>
                  </div>
                </div>
                <div>
                  <div class="small text-gray-500">
                    {{ demand.demand_date }}
                  </div>
                  <span class="font-weight-bold">{{
                    demand.lastname +
                    " " +
                    demand.firstname +
                    "(p. " +
                    demand.document_issuer_country_name +
                    ")"
                  }}</span>
                </div>
              </button>
            </div>
            <!-- <a class="dropdown-item d-flex align-items-center" href="#">
              <div class="mr-3">
                <div class="icon-circle bg-success">
                  <i class="fas fa-donate text-white"></i>
                </div>
              </div>
              <div>
                <div class="small text-gray-500">December 7, 2019</div>
                $290.29 has been deposited into your account!
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="#">
              <div class="mr-3">
                <div class="icon-circle bg-warning">
                  <i class="fas fa-exclamation-triangle text-white"></i>
                </div>
              </div>
              <div>
                <div class="small text-gray-500">December 2, 2019</div>
                Spending Alert: We've noticed unusually high spending for your
                account.
              </div>
            </a> -->
            <router-link
              class="dropdown-item text-center small text-gray-500"
              :to="{ name: 'matcheds' }"
            >
              Afficher tout</router-link
            >
          </div>
        </li>
        '
        <!-- Nav Item - Messages -->
        <!-- <li class="nav-item dropdown no-arrow mx-1">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="messagesDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fas fa-envelope fa-fw"></i> -->
        <!-- Counter - Messages -->
        <!-- <span class="badge badge-danger badge-counter">7</span> -->
        <!-- </a> -->
        <!-- Dropdown - Messages -->
        <!-- <div
            class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in"
            aria-labelledby="messagesDropdown"
          >
            <h6 class="dropdown-header">Message Center</h6>
            <a class="dropdown-item d-flex align-items-center" href="#">
              <div class="dropdown-list-image mr-3">
                <img
                  class="rounded-circle"
                  src="https://source.unsplash.com/fn_BT9fwg_E/60x60"
                  alt
                />
                <div class="status-indicator bg-success"></div>
              </div>
              <div class="font-weight-bold">
                <div class="text-truncate">
                  Hi there! I am wondering if you can help me with a problem
                  I've been having.
                </div>
                <div class="small text-gray-500">Emily Fowler · 58m</div>
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="#">
              <div class="dropdown-list-image mr-3">
                <img
                  class="rounded-circle"
                  src="https://source.unsplash.com/AU4VPcFN4LE/60x60"
                  alt
                />
                <div class="status-indicator"></div>
              </div>
              <div>
                <div class="text-truncate">
                  I have the photos that you ordered last month, how would you
                  like them sent to you?
                </div>
                <div class="small text-gray-500">Jae Chun · 1d</div>
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="#">
              <div class="dropdown-list-image mr-3">
                <img
                  class="rounded-circle"
                  src="https://source.unsplash.com/CS2uCrpNzJY/60x60"
                  alt
                />
                <div class="status-indicator bg-warning"></div>
              </div>
              <div>
                <div class="text-truncate">
                  Last month's report looks great, I am very happy with the
                  progress so far, keep up the good work!
                </div>
                <div class="small text-gray-500">Morgan Alvarez · 2d</div>
              </div>
            </a>
            <a class="dropdown-item d-flex align-items-center" href="#">
              <div class="dropdown-list-image mr-3">
                <img
                  class="rounded-circle"
                  src="https://source.unsplash.com/Mv9hjnEUHR4/60x60"
                  alt
                />
                <div class="status-indicator bg-success"></div>
              </div>
              <div>
                <div class="text-truncate">
                  Am I a good boy? The reason I ask is because someone told me
                  that people say this to all dogs, even if they aren't good...
                </div>
                <div class="small text-gray-500">Chicken the Dog · 2w</div>
              </div>
            </a>
            <a class="dropdown-item text-center small text-gray-500" href="#"
              >Read More Messages</a
            >
          </div> -->
        <!-- </li> -->

        <div class="topbar-divider d-none d-sm-block"></div>

        <!-- Nav Item - User Information -->
        <li class="nav-item dropdown no-arrow">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="userDropdown"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <!-- logged user identity -->
            <span class="mr-2 d-none d-lg-inline text-gray-600 small"
              >{{ profileName() }}
            </span>
            <img
              class="img-profile rounded-circle"
              src="@/assets/flag_of_benin.png"
            />
          </a>
          <!-- Dropdown - User Information -->
          <div
            class="dropdown-menu dropdown-menu-right shadow animated--grow-in"
            aria-labelledby="userDropdown"
          >
            <!-- <a class="dropdown-item" href="#">
              <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              Profile
            </a>
            <a class="dropdown-item" href="#">
              <i class="fas fa-cogs fa-sm fa-fw mr-2 text-gray-400"></i>
              Settings
            </a>
            <a class="dropdown-item" href="#">
              <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
              Activity Log
            </a> -->
            <router-link class="dropdown-item" :to="{ name: 'user-view' }">
              <i class="fas fa-user fa-sm fa-fw mr-2 text-gray-400"></i>
              Voir mon profile
            </router-link>
            <router-link
              class="dropdown-item"
              :to="{ name: 'change-password' }"
            >
              <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
              Changer votre password
            </router-link>
            <!-- <router-link class="dropdown-item" to="#">
              <i class="fas fa-list fa-sm fa-fw mr-2 text-gray-400"></i>
              Réinitialiser password
            </router-link> -->
            <div class="dropdown-divider"></div>
            <router-link
              class="dropdown-item"
              to=""
              data-toggle="modal"
              data-target="#logoutModal"
            >
              <i class="fas fa-sign-out-alt fa-sm fa-fw mr-2 text-gray-400"></i>
              Déconnexion
            </router-link>
          </div>
        </li>
      </ul>
    </nav>
    <!-- End of Topbar -->

    <!-- Logout Modal-->
    <div
      class="modal fade"
      id="logoutModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Déconnexion</h5>
            <button
              class="close"
              type="button"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            Vous êtes sûr de vouloir vous déconnecter ?
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-secondary"
              type="button"
              data-dismiss="modal"
            >
              Annuler
            </button>
            <button
              class="btn btn-primary"
              data-dismiss="modal"
              @click="logout"
            >
              Valider
            </button>
          </div>
        </div>
      </div>

      
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { LOGOUT, FETCH_MATCHED, FETCH_DEMANDS } from "@/store/actions.type";
import { SET_LOADING } from "@/store/mutations.type";
import { CURRENT_STATE } from "@/helpers/jwt";
import JwtService from "@/helpers/jwt";
import { P_READ_DEMAND } from "@/helpers/permissions";


export default {
  name: "Header",
  data() {
    return {
      //connection: null,
      time: 30000,
      identifiant: "",
      statut: "",
      P_READ_DEMAND,
    };
  },
  mounted() {
    // Socket connection to the server
    //console.log("Starting connection to WebSocket Server");
    //this.connection = new WebSocket("wss://echo.websocket.org");
    //this.connection.onmessage = this.handleSocketMessage;
    /* this.connection.onopen = function (event) {
      console.log(event);
      console.log("Successfully connected to the echo websocket server...");
    }; */
    //reload the page
    //setTimeout(this.reloadPage, 5000);
    /* window.addEventListener("load.once", function () {
      window.location.href = "/";
    }); */
  },
  computed: {
    ...mapGetters(["logedUser", "nombreDemandeEnAttente", "matcheds", "userPermissions"]),
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    },
    second() {
      return this.time / 1000;
    },
  },
  watch: {
    isIdle: function () {
      //this.sessionExpired();
    },
  },
  methods: {
    getDemands(page = 1) {
      if (page === null) {
        return;
      }

      if (typeof page != "number") {
        page = 1;
      }

      this.$store.commit(SET_LOADING, true);

      let params = {};
      params.page = page;
      
      if (this.identifiant) params.reference = this.identifiant;
      
      if (this.statut == "VALIDATED") {
        (params.state = "GENERATED"),
          (params.matched = "REDLIST,INTERPOL,GEN_AUTO");
      } else if (this.statut != "VALIDATED" && this.statut) {
        params.state = this.statut;
      } else {
        params.state = "GENERATED,PROCESSING,VALIDATION";
      }

      this.$store
        .dispatch(FETCH_DEMANDS, params)
        .catch((error) => {
          this.error = `${error}`;
          if (error.errors) {
            this.error += ` \n ${JSON.stringify(error.errors)} `;
          }
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
          this.$router.push("/demands?auto=no");
          // datatable
          // $(document).ready(function () {
          //   $("#dataTable").DataTable({
          //     language: frLocalDatatable,
          //   });
          // });
        });
    },
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        window.localStorage.removeItem(CURRENT_STATE);
        window.location.href = "/";
        //this.$router.push({ name: "login" });
      });
    },
    view(id) {
      this.$store.commit(SET_LOADING, true);
      this.$store
        .dispatch(FETCH_MATCHED, id)
        .then(() => {
          //this.$store.commit(SET_LOADING, false);
          this.$router.push({ name: "matched-view" });
        })
        .catch(() => {
          //this.$store.commit(SET_LOADING, false);
        })
        .finally(() => {
          this.$store.commit(SET_LOADING, false);
        });
    },
    /*  sendMessage(message) {
      console.log("Hello");
      console.log(this.connection);
      this.connection.send(message);
    }, */
    // handleSocketMessage(event) {
    //   console.log("Message", event);
    // },
    /* reloadPage() {
      //this.$router.push({ name: "home" });
      window.location.href = "/";
    }, */
    sessionExpired() {
      let timerId = setInterval(() => {
        this.time -= 1000;
        if (!this.$store.state.idleVue.isIdle) {
          clearInterval(timerId);
          this.time = 30000;
        }
        if (this.time < 1) {
          clearInterval(timerId);

          JwtService.destroy();
          window.localStorage.removeItem(CURRENT_STATE);
          this.$store.state.auth.isAuthenticated = false;
          this.$store.state.auth.logedUser = {};
          window.location.href = "/";
        }
      }, 1000);
      //alert("Vous..............");
    },
    profileName() {
      let name = `${this.logedUser.firstname} ${this.logedUser.lastname}`
        ? `${this.logedUser.firstname} ${this.logedUser.lastname}`
        : this.logedUser.email;

      if (name.length > 25) {
        name = name.substr(0, 22) + "...";
      }

      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_variables.scss";

//$base-color: #0a3764;
.dropdown .dropdown-menu {
  font-size: 1rem;
}
.topbar .dropdown-list .dropdown-header {
  background-color: $base-color;
  border: 1px solid $base-color;
}
.btn-primary {
  background-color: $base-color;
  border-color: $base-color;
}
</style>
